export function publicBookingId(encryptedRequestId: string, bookingIndex: number) {
    return `${encryptedRequestId}__${bookingIndex}`;
}
